<template>
    <div v-if="historyBets && historyBets.length > 0">
        <div
            v-for="(historyBet, index) in historyBets"
            :key="index"
            class="row-history"
            :class="{ 'row-color-even': index % 2 !== 0 }"
        >
            <div class="row-history__left">
                <p class="row-history__left-title">
                    {{
                        historyBet.city.name.concat(
                            ' ' + historyBet.category.name,
                        )
                    }}
                </p>
                <p class="row-history__left-number">
                    <template v-if="historyBet.numbers">
                        <CircleNumber
                            v-for="(number, index) in historyBet.numbers.split(
                                ' - ',
                            )"
                            :key="index"
                            :numberInput="number"
                        />
                    </template>
                </p>
                <p class="common-title">
                    Tiền cược:
                    <span class="currency-color">{{
                        (historyBet.amount / Number(clientBalanceUnit))
                            | currency_not_symbol
                    }}</span>
                    K
                </p>
                <p class="common-title">
                    Tiền thắng:
                    <span class="currency-color">{{
                        (historyBet.amount_win / Number(clientBalanceUnit))
                            | currency_not_symbol
                    }}</span>
                    K
                </p>
            </div>
            <div class="row-history__right ">
                <p class="mb-2">No. {{ historyBet.id }}</p>
                <p class="common-title-date">
                    {{
                        historyBet.date.concat(
                            '-' +
                                new Date(
                                    historyBet.created_at.substr(0, 10),
                                ).getFullYear(),
                        )
                    }}
                </p>
                <p
                    :class="[
                        historyBet.status === Status.WIN
                            ? 'win'
                            : historyBet.status === Status.LOST
                            ? 'lost'
                            : 'waiting',
                    ]"
                >
                    {{
                        historyBet.status === Status.WIN
                            ? 'Đã thắng'
                            : historyBet.status === Status.LOST
                            ? 'Đã thua'
                            : 'Đang chờ'
                    }}
                </p>
                <Button
                    @click="clickPlayAgain(historyBet)"
                    value="Chơi Lại"
                    theme="dark"
                    variant="secondary"
                    class="row-history__right--btn-play-now"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CircleNumber from '../CircleNumber/CircleNumber';
import Button from '../Button/Button';

const Status = {
    WIN: 1,
    LOST: 2,
    WAITING: 0,
};
export default {
    components: {
        CircleNumber,
        Button,
    },
    props: {
        historyBets: {
            type: Array,
            require: false,
            default: () => [],
        },
    },
    data() {
        return {
            Status: Status,
            clientBalanceUnit: process.env.VUE_APP_CLIENT_BALANCE_UNIT,
        };
    },
    methods: {
        clickPlayAgain(result) {
            this.$emit('play-again', result);
        },
    },
};
</script>
<style scoped lang="scss">
@import 'HistoryRowTableMB';
</style>
